import { defineComponent as f, computed as i, useCssModule as c, openBlock as n, createElementBlock as m, mergeProps as d, renderSlot as p, normalizeProps as C, createCommentVNode as h } from "vue";
import y from "../../utils/mapClasses.mjs";
import { responsiveModifyClass as b } from "../../utils/buildClass.mjs";
import g from "../../utils/propValidator.mjs";
import $ from "./styles/CdrIcon.module.scss.mjs";
import v from "../../../_virtual/_plugin-vue_export-helper.mjs";
const z = f({
  name: "CdrIcon",
  props: {
    /**
     * Only on CdrIcon. Sets the href attribute for use with SVG symbol sprite (see @rei/cedar-icons).
     */
    use: String,
    /**
     * Sets icon fill to "inherit" so as to use parent/ancestor fill color.
     */
    inheritColor: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "medium",
      validator: (e) => g(e, ["small", "medium", "large"])
    }
  },
  setup(e, r) {
    const s = "cdr-icon", o = !r.attrs["aria-label"] && !r.attrs["aria-labelledby"], t = i(() => e.inheritColor && `${s}--inherit-color`), a = i(() => e.size && b(s, "", e.size)), l = {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    };
    o && (l["aria-hidden"] = !0);
    const u = {
      href: e.use,
      "xlink:href": e.use
    };
    return {
      style: c(),
      baseClass: s,
      inheritColorClass: t,
      sizeClass: a,
      dataObj: l,
      hrefAttrs: u,
      mapClasses: y
    };
  }
});
function w(e, r, s, o, t, a) {
  return n(), m("svg", d(e.dataObj, {
    class: e.mapClasses(e.style, e.baseClass, e.sizeClass, e.inheritColorClass)
  }), [p(e.$slots, "default"), e.use ? (n(), m("use", C(d({
    key: 0
  }, e.hrefAttrs)), null, 16)) : h("", !0)], 16);
}
const k = {
  $style: $
}, I = /* @__PURE__ */ v(z, [["render", w], ["__cssModules", k]]);
export {
  I as default
};
